import { UpdateInvoiceInput } from '__generated__/GQL';
import { InvoiceFormSchema } from 'features/Work/form/invoiceForm.schema';
import { computeTasksDiff } from 'features/Work/utils';
import { formatInvoiceTask } from 'features/Work/utils/formatInvoiceTask';

import { RetrievedInvoice } from '../../../hooks/queries/useRetrievedInvoiceQuery';

export const formatUpdateMutationInput = (
  invoice: InvoiceFormSchema,
  retrievedInvoice: RetrievedInvoice,
): UpdateInvoiceInput => {
  const sortedTasksWithoutTotals = invoice.tasks.map(formatInvoiceTask);

  const { createdTasks, deletedTaskIds, updatedTasks } = computeTasksDiff(
    sortedTasksWithoutTotals,
    retrievedInvoice.tasks,
  );

  return {
    allowCreditCardPayment: invoice.allowCreditCardPayment,
    allowIbanPayment: invoice.allowIbanPayment,
    clientId: invoice.clientId,
    createdTasks,
    currency: invoice.currency,
    deletedTaskIds,
    fiscalId: invoice.fiscalId,
    invoiceId: retrievedInvoice.invoiceId,
    lateFeePercentage: invoice.lateFeePercentage,
    lateMaxDays: invoice.lateMaxDays,
    settings: {
      displayTradeName: invoice.settings.displayTradeName,
      issuerEmail: invoice.settings.issuerEmail,
      legalMentions: invoice.settings.legalMentions,
    },
    startAt: invoice.startAt,
    subtitle: invoice.subtitle,
    title: invoice.title,
    updatedTasks,
  };
};
